import { render, staticRenderFns } from "./instructions.vue?vue&type=template&id=4890e9e0&scoped=true&"
import script from "./instructions.vue?vue&type=script&lang=js&"
export * from "./instructions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4890e9e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/imc/portal/dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4890e9e0')) {
      api.createRecord('4890e9e0', component.options)
    } else {
      api.reload('4890e9e0', component.options)
    }
    module.hot.accept("./instructions.vue?vue&type=template&id=4890e9e0&scoped=true&", function () {
      api.rerender('4890e9e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "assets/js/components/com_imc/instructions/instructions.vue"
export default component.exports